import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ClientCache } from '@xanadu/cache';
import { PanelComponent, Register } from '@xanadu/core';
import { Client } from '@xanadu/model';

@Component({
    selector: 'app-client-panel',
    templateUrl: './client-panel.component.html',
    styleUrls: ['./client-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('client-panel')
export class ClientPanelComponent extends PanelComponent<Client> {
    private readonly clientCache = inject(ClientCache);

    private tabClient = { caption: 'Client', active: true, hidden: false };

    public metaId: any = { id: 'clientId', name: 'Client Id', mandatory: true, info: 'Client Id' };
    public metaSecret: any = { id: 'secret', name: 'Client Secret', mandatory: true, info: 'Client secret' };

    protected override get nodeType(): string | undefined {
        return 'client';
    }

    protected override setup(client: Client): void {
        super.setup(client);

        this.tabs = [
            this.tabClient
        ];
        this.tabSelected = this.tabClient;
    }

    protected override refresh(client: Client): void {
        super.refresh(client);

        this.clientCache.update();
    }

    protected override load(client: Client, form: any): string | undefined {
        super.load(client, form);

        client.clientId = form.clientId;
        client.secret = form.secret;

        return;
    }
}
